import React from "react";
import "./Notfound.scss";

function Notfound() {
  return (
    <main className="main-Container">
      <img
        src="./assets/img/underMaintenence.png"
        alt="Site Under Maintenance"
        className="underMaintenenceImg"
      />
      <h1 className="heading">Site Under Maintenance</h1>
      <p className="para">
        Our website is under construction, we are working very hard to give you
        the best experience with this one.
      </p>
    </main>
  );
}

export default Notfound;
